import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-payment-account',
  standalone: true,
  imports: [RouterOutlet, TranslateModule],
  templateUrl: './payment-account.component.html',
  styleUrl: './payment-account.component.scss'
})
export class PaymentAccountComponent {}
